import styled from "styled-components";
import { ReactComponent as Edit } from "../../../assets/icons/edit-3.svg";
import { ReactComponent as Status } from "../../../assets/icons/list-status.svg";
import TableItem from "../../../components/Table/TableItem";
import FirstTableItem from "../../../components/Table/FirstTableItem";
import { ReactComponent as ChevronSvg } from "../../../assets/icons/chevron-right.svg";

export const Chevron = styled(ChevronSvg)`
  height: 23px;
  width: auto;

  fill: #55a1e8;

  transform: ${(props) => (props.$ar ? "rotate(180deg)" : "unset")};
`;

export const TableBodyRow = styled.tr`
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  justify-content: space-between;
  display: flex;
  width: 100%;
  background-color: ${(props) => props.$active && "#48488815"};

  cursor: ${(props) => (props.$offClick ? "default" : "pointer")};

  min-height: 6.4rem;
  gap: 0rem;

  &:last-of-type {
    border-bottom: none;
  }
  &:hover {
    background-color: #48488815;
    transition: all 0.2s ease-in-out;
  }
  &:nth-child(even) {
    background-color: #48488810;
  }
`;

export const FirstItem = styled(FirstTableItem)`
  padding-left: 1.6rem;
`;

export const LastTableItem = styled(TableItem)`
  padding-right: 1.6rem;
  justify-content: flex-end;

  cursor: ${(props) => (props.$offClick ? "default" : "pointer")};

  &:active {
    opacity: ${(props) => (props.$offClick ? 1 : 0)};
  }
`;

export const MainContainer = styled.div`
  flex-direction: row;
  background: #f6f6f9;

  min-height: 100vh;
  display: flex;
`;

export const HeaderWrapper = styled.div`
  position: fixed;
  z-index: 1000;
  width: 100%;
  justify-content: center;
`;

export const SectionTitle = styled.h1`
  color: #484888;
  font-family: "Avenir";
  user-select: none;
  font-size: 35px;

  font-weight: 800;

  letter-spacing: -0.178px;
  @media (max-width: 870px) {
    display: none;
  }
`;
export const StyledTitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 80px;
  width: 100%;
  @media (max-width: 870px) {
    margin-bottom: 0px;
    justify-content: flex-end;
  }
`;
export const Button = styled.div`
  border-radius: 30px;
  user-select: none;
  background: #484888;
  height: 45px;
  padding: 5px 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  color: #fff;
  text-align: center;
  font-family: "Avenir";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: 0.08px;
  box-shadow: 0px 12px 24px -6px rgba(0, 0, 0, 0.25);
  cursor: pointer;

  &:active {
    transition: all 0.2s ease-in-out;
    scale: 0.95;
  }
  @media (max-width: 1075px) {
    height: 35px;
    padding: 5px 20px;
    font-size: 12px;
  }
`;
export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 20px;
  @media (max-width: 1205px) {
    gap: 10px;
  }
  @media (max-width: 1075px) {
    margin-top: 6px;
    flex-direction: column;
  }
`;

export const Column = styled.div`
  flex-direction: column;
  display: flex;
  width: 100%;
  margin-top: 75px;

  transition: all 0.3s ease-in-out;
  padding: ${(props) =>
    props.$loggedIn
      ? props.$open
        ? props.$ar
          ? "8rem 30rem 8rem 4rem"
          : "8rem 4rem 8rem 30rem"
        : !props.$ar
        ? "8rem 4rem 8rem 10rem"
        : "8rem 10rem 8rem 4rem"
      : "8rem 4rem"};

  @media (max-width: 870px) {
    padding: ${(props) =>
      props.$upgradePackage ? "60px 40px 40px 40px" : "0px 40px 40px 40px"};
  }
  @media (max-width: 760px) {
    align-items: center;
  }
`;
export const Message = styled.span`
  font-family: "Avenir-Heavy";
  font-style: normal;

  font-size: 24px;
  // line-height: 33px;

  letter-spacing: -0.177777px;
  text-align: center;

  color: #484888;
  @media (max-width: 990px) {
    font-size: 20px;
  }
  @media (max-width: 850px) {
    font-size: 17px;
  }
  @media (max-width: 870px) {
    font-size: 22px;
  }
  @media (max-width: 650px) {
    font-size: 18px;
  }
  @media (max-width: 540px) {
    font-size: 14px;
  }
`;

export const Content = styled.div`
  border: 1px solid #48488877;
  width: 100%;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 25px 0px 15px 0px;
`;

export const Text = styled.span`
  font-family: "Avenir-Black";
  font-style: normal;
  user-select: none;
  font-size: 24px;
  line-height: 33px;

  letter-spacing: -0.177777px;

  color: #484888;
  @media (max-width: 450px) {
    font-size: 14px;
  }
`;

export const Desc = styled.span`
  font-family: "Avenir-Light";
  font-style: normal;

  font-size: 20px;
  line-height: 27px;
  letter-spacing: -0.177777px;

  color: rgba(69, 69, 132, 0.6);
`;

export const TextContainer = styled.div`
  display: flex;
  margin-top: 10%;
  margin-bottom: 10%;
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 25px;
  margin-top: 40px;
  align-items: center;
  justify-content: center;
`;

export const Buttons = styled.div`
  display: flex;
  cursor: pointer;
  flex-direction: row;
  align-items: flex-start;
  padding: 12px 15px;
  align-items: center;
  font-family: "Avenir-Medium";
  font-style: normal;

  font-size: 20px;
  line-height: 27px;
  letter-spacing: -0.177777px;
  color: #ffffff;
  gap: 10px;
  justify-content: center;
  background: linear-gradient(180deg, #7f7fac 0%, #484888 100%), #ffffff;
  border-radius: 15px;
  &:hover {
    background: #484888;
  }
  &:active {
    transition: all 0.2s ease;
    transform: scale(0.95);
  }
`;

export const TableContainer = styled.div`
  overflow-x: auto;
  margin-top: 20px;
  margin-bottom: 80px;
  width: 1800px;
  @media (max-width: 2125px) {
    width: 100%;
  }
`;

export const DetailsTd = styled.td`
  text-align: center;
`;

export const InvoiceTd = styled.td`
  text-align: center;
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;

  justify-content: space-between;
  align-items: center;
  gap: 20px;
  margin-top: 40px;
  @media (max-width: 2125px) {
    width: 100%;
  }
`;

export const PageButton = styled.button`
  padding: 2px 7px;
  border: none;
  background: transparent;
  font-family: "Avenir-Medium";
  font-size: 14px;
  user-select: none;
  color: #484888;
  cursor: pointer;
  &:active {
    opacity: 0.6;
  }
`;

export const PageCountContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 40px;
  gap: 5px;
  width: 1800px;

  margin-top: -70px;
  @media (max-width: 2125px) {
    width: 100%;
  }
`;

export const StyledTd = styled.td`
  text-align: center;
  min-width: 150px !important;
`;
export const StyledAHref = styled.a``;
export const StyledTdEdit = styled.td`
  text-align: left;
  min-width: 40px !important;
`;

export const StyledTdFirst = styled(StyledTd)`
  text-align: left;
  min-width: unset !important;
  padding-bottom: 10px;
`;
export const StyledTh = styled.th`
  text-align: center;
  font-family: "Avenir";
`;

export const EditIcon = styled(Edit)`
  cursor: pointer;
`;
export const StatusIcon = styled(Status)`
  cursor: pointer;
  &:hover {
    scale: 1.1;

    transition: all 0.2s ease-in-out;
  }
`;
export const LoaderContainer = styled.div`
  padding: 120px 0px;
  background-color: transparent;
`;
export const ViewMoreText = styled.span`
  color: #55a1e8;
  user-select: none;
  font-family: "Avenir";
  text-transform: uppercase;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0.067px;

  @media (max-width: 450px) {
    font-size: 10px;
  }
`;
export const ViewMoreContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  cursor: pointer;
`;

export const TableInput = styled.input`
  border: none;
  outline: none;
  background-color: transparent;
  font-family: "Avenir-Light";
  font-style: normal;
  font-size: 18px;
  line-height: 25px;
  letter-spacing: -0.177777px;
  color: #484888;
  text-align: center;
  padding: 3px;

  max-width: 140px !important;
  &:focus {
    outline: none;
    border-top: none;
    border-right: none;
    border-left: none;
    border-bottom: 1px solid #484888;
  }
`;
export const TableInputFirst = styled(TableInput)`
  text-align: left;
`;
export const StyledTdAll = styled(StyledTd)`
  padding-bottom: 10px;
`;
export const StyledTable = styled.table`
  width: 100%;
`;
